import * as React from "react";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { formatDate } from "../../helper";

export default function DownloadsTable() {
  const [downloads, setDownloads] = React.useState([]);
  const [err, setErr] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 60,
    },
    {
      field: "sender",
      headerName: "sender",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "recipient_name",
      headerName: "recipient_name",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "recipient_email",
      headerName: "recipient_email",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "recipient_phone",
      headerName: "recipient_phone",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "url_code",
      headerName: "url_code",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "phone_code",
      headerName: "phone_code",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "expiry",
      headerName: "expiry",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "downloaded",
      headerName: "downloaded",
      minWidth: 150,
      flex: 2,
    },
    {
      field: "download_ip",
      headerName: "download_ip",
      minWidth: 150,
      flex: 2,
    },
  ];

  React.useEffect(() => {
    axios
      .get(`/down_loads`)
      .then((res) => {
        const downloadsFromApi = res.data.downloads;
        downloadsFromApi.map((download) => {
          download.expiry = formatDate(download.expiry);
        });
        setDownloads(downloadsFromApi);
        setIsLoading(false);
      })
      .catch((err) => {
        setErr(err.message);
      });
  }, []);

  return (
    <React.Fragment>
      {err ? (
        <p>{err}</p>
      ) : (
        <div
          id="m"
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "flex-end",
          }}
        >
          <Box sx={{ height: 660, width: "100%" }}>
            <DataGrid
              loading={isLoading}
              rows={downloads}
              columns={columns}
              pageSize={10}
            
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
              experimentalFeatures={{ newEditingApi: true }}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "desc" }],
                },
              }}
            />
          </Box>
        </div>
      )}
    </React.Fragment>
  );
}
